module.exports = __webpack_public_path__ + "img/header.d6d5f4aa.jpg";